/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Transact(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                fill='none'
                height='21'
                viewBox='0 0 22 21'
                width='22'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M15.0736 15.8651L15.0736 20.1602M15.0736 20.1602L2.26789 20.1602C1.50716 20.1602 1 19.9481 1 19.6299L0.999999 2.13171C0.999999 1.81356 1.50715 1.60146 2.26789 1.60146L13.8057 1.60146C14.5664 1.60146 14.4872 1.60146 14.4872 1.60146M15.0736 20.1602L15.0736 11.5436'
                    stroke='white'
                    strokeWidth='0.59334'
                />
                <path
                    d='M18.1427 2.16741L17.1687 0.846322L14.259 3.58726L13.635 2.74094L12.7158 6.19525L15.8875 5.79596L15.2635 4.94964C15.233 4.90835 18.1427 2.16741 18.1427 2.16741Z'
                    stroke='white'
                    strokeWidth='0.59334'
                />
                <path
                    d='M14.5311 9.35519L15.4531 10.7125L18.4706 8.09385L19.0613 8.96338L20.1165 5.55315L16.9292 5.82459L17.5199 6.69412C17.5487 6.73654 14.5311 9.35519 14.5311 9.35519Z'
                    stroke='white'
                    strokeWidth='0.59334'
                />
                <path
                    d='M7.5958 16.0461V14.7129C6.76026 14.6918 5.90953 14.459 5.4082 14.1415L5.75761 13.2527C6.27413 13.5702 7.01852 13.8241 7.82368 13.8241C8.84152 13.8241 9.52514 13.2739 9.52514 12.5332C9.52514 11.8137 8.96305 11.3694 7.89964 10.9673C6.44124 10.4171 5.52974 9.82454 5.52974 8.6818C5.52974 7.58138 6.38047 6.75607 7.70214 6.56562V5.23242H8.59845V6.50213C9.46438 6.52329 10.0417 6.73491 10.467 6.96769L10.1024 7.83533C9.79859 7.68719 9.20612 7.39093 8.29462 7.39093C7.18563 7.39093 6.77545 8.00462 6.77545 8.53367C6.77545 9.21084 7.30716 9.57059 8.55288 10.0362C10.0265 10.5864 10.7709 11.2847 10.7709 12.4486C10.7709 13.4855 9.98089 14.459 8.5073 14.6918V16.0673H7.5958V16.0461Z'
                    fill='white'
                />
                <path
                    d='M8.72035 16.3646H7.38349V15.0102C6.60871 14.9679 5.81874 14.7351 5.31742 14.4177L5.10474 14.2907L5.66683 12.8729L5.84913 12.9787C6.41122 13.3173 7.14042 13.5289 7.82404 13.5289C8.67478 13.5289 9.31283 13.1056 9.31283 12.5343C9.31283 12.0264 8.85708 11.6455 7.83924 11.2646C6.60871 10.799 5.31742 10.1853 5.31742 8.68282C5.31742 7.4766 6.16815 6.56664 7.48983 6.29153V4.91602H8.8115V6.18573C9.46474 6.22805 10.0268 6.37618 10.5434 6.67245L10.7712 6.79942L10.1939 8.17494L10.0116 8.09029C9.70781 7.94216 9.14572 7.66705 8.29499 7.66705C7.39868 7.66705 6.9885 8.11145 6.9885 8.51353C6.9885 8.95792 7.41387 9.27535 8.59882 9.71975C9.76858 10.1641 10.9687 10.8202 10.9687 12.4285C10.9687 13.677 10.0876 14.6505 8.70516 14.9256V16.3646H8.72035ZM7.80885 15.772H8.29499V14.4388L8.49248 14.4177C9.92049 14.1849 10.5585 13.2749 10.5585 12.4708C10.5585 11.5185 9.93569 10.8836 8.50767 10.3546C7.21638 9.86788 6.56314 9.46581 6.56314 8.55585C6.56314 7.89983 7.01889 7.11684 8.29499 7.11684C9.10014 7.11684 9.66224 7.32846 10.0116 7.49776L10.1636 7.15917C9.70781 6.94755 9.20649 6.84174 8.61401 6.84174H8.40133V5.57203H7.93039V6.88407L7.73289 6.90523C6.53275 7.07452 5.75798 7.79402 5.75798 8.72514C5.75798 9.57162 6.38084 10.1218 7.97596 10.7144C8.90265 11.0741 9.75339 11.5397 9.75339 12.5766C9.75339 13.5077 8.96342 14.1637 7.83924 14.1637C7.15561 14.1637 6.45679 13.9944 5.86432 13.677L5.72759 14.0368C6.22892 14.2907 6.92774 14.4388 7.61136 14.46H7.82404V15.772H7.80885Z'
                    fill='white'
                />
            </svg>
        </SvgIcon>
    );
}